import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app'
import store from '@/store/index'

// Main Routes
import CreateChannel from '../components/_Routes/CreateChannel'
import CreationComplete from '../components/_Routes/CreationComplete'
import Channel from '../components/_Routes/Channel'
import SignUp from '../components/_Routes/SignUp'
import DesignSystem from '../components/_Routes/DesignSystem'

// Child Routes
import ChannelLanding from '../components/_ChildRoutes/ChannelLanding'
import ChannelSettings from '../components/_ChildRoutes/ChannelSettings'
import ChannelFans from '../components/_ChildRoutes/ChannelFans'
import ChannelSignUp from '../components/_ChildRoutes/ChannelSignUp'
import Profile from '../components/_ChildRoutes/Profile'
import Page from '../components/_ChildRoutes/Page'

Vue.use(Router)

const subdomains = window.location.host.split('.')

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
      path: '/sign-up-in',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/create-a-channel',
      name: 'create',
      component: CreateChannel,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/my-design-system',
      name: 'design-system',
      component: DesignSystem
    },
    {
      path: '/creation-complete',
      name: 'complete',
      component: CreationComplete,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      component: Channel,
      children: [
        {
          path: '',
          name: 'channel-landing',
          component: ChannelLanding
        },
        {
          path: 'subscribe',
          name: 'channel-sign-up',
          component: ChannelSignUp
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        {
          path: 'settings',
          name: 'channel-settings',
          component: ChannelSettings,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'fans',
          name: 'channel-fans',
          component: ChannelFans,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/p/:page_id',
          name: 'page',
          component: Page
        }
      ]
    },
  ]
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (subdomains.length > 1) {
      if (subdomains[0].endsWith('-sandbox')) {
        subdomains[0] = subdomains[0].replace('-sandbox', '')
      }
      store.commit('UPDATE_CHANNEL_ID', subdomains[0])
    } else {
      store.commit('UPDATE_CHANNEL_ID', 'tests')
    }

    if (process.env.NODE_ENV === 'development' && subdomains.length <=1) {
      console.error(`You need to use a subdomain for development. Try ${process.env.VUE_APP_SUBDOMAIN}.localhost:8080. Or update your .env.local`)
    }

    if (requiresAuth && !currentUser) {
        next('/sign-up-in')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})

export default router
